"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _components = require("@quarkly/components");

var _widgets = require("@quarkly/widgets");

var _fi = require("react-icons/fi");

var _ComponentNotice = _interopRequireDefault(require("./ComponentNotice"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var overrides = {
  Popup: {
    kind: 'Box',
    props: {
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      'align-items': 'center',
      'justify-content': 'center',
      display: 'flex',
      position: 'fixed',
      'z-index': '105'
    }
  },
  'Popup :open': {
    kind: 'Box',
    props: {
      'pointer-events': 'all',
      visibility: 'visible',
      opacity: '1'
    }
  },
  'Popup :closed': {
    kind: 'Box',
    props: {
      'pointer-events': 'none',
      visibility: 'hidden',
      opacity: '0'
    }
  },
  Wrapper: {
    kind: 'Box',
    props: {
      'padding-top': '40px',
      'min-width': '320px',
      background: '#FFFFFF',
      'box-shadow': "\n\t\t\t\t0 14px 28px rgba(0,0,0,0.25),\n\t\t\t\t0 10px 10px rgba(0,0,0,0.22)\n\t\t\t",
      'border-radius': '4px',
      position: 'relative',
      overflow: 'hidden',
      'z-index': '107'
    }
  },
  'Wrapper :open': {
    kind: 'Box',
    props: {
      transform: 'scale(1)'
    }
  },
  'Wrapper :closed': {
    kind: 'Box',
    props: {
      transform: 'scale(.7)'
    }
  },
  Content: {
    kind: 'Box',
    props: {
      'min-height': '0px'
    }
  },
  Overlay: {
    kind: 'Box',
    props: {
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0, .3)',
      position: 'fixed',
      'z-index': '106'
    }
  },
  'Button Close': {
    kind: 'Icon',
    props: {
      category: 'fi',
      defaultIcon: _fi.FiX,
      size: '24px',
      color: '--dark',
      top: '0',
      right: '0',
      padding: '8px',
      background: 'none',
      'user-select': 'none',
      cursor: 'pointer',
      position: 'absolute',
      'z-index': '109'
    }
  },
  'Button Open': {
    kind: 'Button',
    props: {
      children: 'Open Popup'
    }
  }
};

var PopupComponent = function PopupComponent(_ref) {
  var animDuration = _ref.animDuration,
      animFunction = _ref.animFunction,
      props = _objectWithoutProperties(_ref, ["animDuration", "animFunction"]);

  var _useOverrides = (0, _components.useOverrides)(props, overrides),
      override = _useOverrides.override,
      children = _useOverrides.children,
      rest = _useOverrides.rest;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isEmpty = _useState4[0],
      setEmpty = _useState4[1];

  var contentRef = (0, _react.useRef)(null);
  var popupTransition = (0, _react.useMemo)(function () {
    return isOpen ? "visibility ".concat(animDuration, " step-start, opacity ").concat(animDuration, " ").concat(animFunction) : "visibility ".concat(animDuration, " step-end, opacity ").concat(animDuration, " ").concat(animFunction);
  }, [isOpen, animFunction, animDuration]);
  var wrapperTransition = (0, _react.useMemo)(function () {
    return "transform ".concat(animDuration, " ").concat(animFunction);
  }, [animFunction, animDuration]);

  var onOpen = function onOpen() {
    return setOpen(true);
  };

  var onClose = function onClose() {
    return setOpen(false);
  };

  (0, _react.useEffect)(function () {
    var _contentRef$current;

    setEmpty(((_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.innerHTML) === '<!--child placeholder-->');
  }, [children]);
  return /*#__PURE__*/_react["default"].createElement(_widgets.Box, rest, /*#__PURE__*/_react["default"].createElement(_widgets.Button, _extends({
    onPointerDown: onOpen
  }, override('Button Open')), override('Button Open').children), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, override('Popup', 'Popup header', 'Popup 10', "Popup ".concat(isOpen ? ':open' : ':closed')), {
    transition: popupTransition
  }), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    onPointerDown: onClose
  }, override('Overlay', "Overlay ".concat(isOpen ? ':open' : ':closed')))), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, override('Wrapper', "Wrapper ".concat(isOpen ? ':open' : ':closed')), {
    transition: wrapperTransition
  }), /*#__PURE__*/_react["default"].createElement(_widgets.Icon, _extends({}, override('Button Close'), {
    onPointerDown: onClose
  })), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, override('Content'), {
    ref: contentRef
  }), children), isEmpty && /*#__PURE__*/_react["default"].createElement(_ComponentNotice["default"], {
    message: "Drag any component here"
  }))));
};

var propInfo = {
  animDuration: {
    title: {
      en: 'Show/hide duration',
      ru: 'Длительность появления и скрытия'
    },
    control: 'input',
    variants: ['0s', '0.1s', '0.2s', '0.3s', '0.5s', '1s'],
    type: 'text',
    category: 'Main',
    weight: 1
  },
  animFunction: {
    title: {
      en: 'Animation timing function',
      ru: 'Функция сглаживания анимации'
    },
    control: 'input',
    variants: ['linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out', 'step-start', 'step-end'],
    type: 'text',
    category: 'Main',
    weight: 1
  }
};
var defaultProps = {
  animDuration: '0.15s',
  animFunction: 'linear'
};
Object.assign(PopupComponent, {
  title: 'Popup',
  description: {
    en: 'This is a pop-up window that appears when clicking on a button',
    ru: 'Всплывающее окно, которое появляется по клику на кнопку'
  },
  propInfo: propInfo,
  defaultProps: defaultProps,
  overrides: overrides
});
var _default = PopupComponent;
exports["default"] = _default;